import classnames from "classnames";
import React, { FC } from "react";
import { FormattedMessage } from "react-intl";

import { ButtonProps, PrimaryRedButton } from "nvent-web/components/Button";

import style from "./common.module.scss";

export interface RequiredFieldLabelProps {
  className?: string;
}

export const RequiredFieldLabel: FC<RequiredFieldLabelProps> = ({ className }) => (
  <p className={classnames(style.requiredFieldsLabel, className)}>
    * <FormattedMessage id="form.requiredFields" />
  </p>
);

export const SubmitButton: FC<ButtonProps> = (props) => (
  <PrimaryRedButton type="submit" size="large" fixedWidth className={style.submitButton} {...props}>
    {props.children}
  </PrimaryRedButton>
);
